import { Tabs } from "antd";
import GoBack from "commons/GoBack";
import { useLocation, useParams } from "react-router-dom";
import EmployeesListing from "./EmployerDetail/EmployeesListing";
import EmployerPayments from "./EmployerDetail/payments";
import EmployerProfile from "./EmployerDetail/profile";
// import EmployerPayments from "./EmployerPayments";

export default function EpcEmployerDetails() {
  const location = useLocation();
  const { id: employerID } = useParams<{ id: string }>();
  const items = [
    {
      key: "1",
      label: "Profile",
      children: <EmployerProfile />,
    },
    {
      key: "2",
      label: "Payments",
      children: <EmployerPayments />,
    },
    {
      key: "3",
      label: "Members",
      children: <EmployeesListing id={employerID} />,
    },
  ];

  return (
    <>
      <GoBack
        backPath="/dpc"
        queryParams={{
          tab: location.state?.tab,
          row: location.state?.id,
        }}
      />
      <Tabs defaultActiveKey="1" centered items={items} size={"large"} />
    </>
  );
}
